import { fetch } from "src/services/apollo-fetch";
import { Mutation, Query } from "../_api";

export default {
    async fetchFutureDeliveryRequest(context, id) {
        const response = await fetch.query({
            query: Query.futureDeliveryRequest,
            variables: { id },
        });
        return response.data.futureDeliveryRequest;
    },
    async fetchMaterialTypes() {
        const response = await fetch.query({
            query: Query.materialTypes,
        });
        return response.data.materialTypes;
    },
    async fetchReceiptLogs(context, data) {
        const variables = {
            excludeAvailableWhenZero: true,
            limit: 200,
            offset: 0,
        };
        if (data && data.search) variables.search = data.search;
        const response = await fetch.query({
            query: Query.receiptLogs,
            variables,
        });
        return response.data.receiptLogs.receiptLogs;
    },
    async updateFutureDeliveryRequest({ commit }, data) {
        // clean up some fields that shouldn't be sent
        delete data.customer;
        delete data.designer;
        const response = await fetch.mutate(
            {
                mutation: Mutation.updateFutureDeliveryRequest,
                variables: {
                    input: data,
                },
            },
            { showToast: false },
        );
        commit(
            "updateFutureDeliveryRequest",
            response.data.updateFutureDeliveryRequest,
        );
    },
    async deleteFutureDeliveryRequest({ commit }, id) {
        await fetch.mutate(
            {
                mutation: Mutation.deleteFutureDeliveryRequest,
                variables: { id },
            },
            { showToast: false },
        );
        commit("removeFutureDeliveryRequest", id);
    },
    async confirmFutureDeliveryRequest({ commit }, id) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.confirmFutureDeliveryRequest,
                variables: { id },
            },
            { showToast: false },
        );
        commit(
            "updateFutureDeliveryRequest",
            response.data.confirmFutureDeliveryRequest,
        );
    },
    async assignFutureDeliveryRequestToReceiptLogs({ commit }, data) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.assignFutureDeliveryRequestToReceiptLogs,
                variables: data,
            },
            { showToast: false },
        );
        commit("removeFutureDeliveryRequest", data.id);
        commit(
            "$_deliveryRequest/addDeliveryRequest",
            response.data.assignFutureDeliveryRequestToReceiptLogs,
            { root: true },
        );
    },
    async addFutureDeliveryRequest({ commit }, data) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.addFutureDeliveryRequest,
                variables: {
                    input: data,
                },
            },
            { showToast: false },
        );
        const newDelivery = response.data.addFutureDeliveryRequest;
        commit("addFutureDeliveryRequest", newDelivery);
    },
    async getPastDueInvoiceInfo() {
        const response = await fetch.query({
            query: Query.pastDueInvoiceInfo,
        });
        return response.data.pastDueInvoiceInfo;
    },
};
